import { PageDirection, PageControlButton } from "./PageControl";
import styled, { css } from "styled-components";

export const PageLengthDescription = styled.div``;

export const PageLengthSelect = styled.select`
  margin: 0 1rem;
  color: ${({ theme }) => theme.colors.darkblue};
  border: none;
  background-color: inherit;
`;

export const PageSelector = styled.div``;

export const PageControl = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const PagePrev = styled(PageDirection)``;
export const PageNext = styled(PageDirection)``;

const SelectedPageStyle = css`
  border: 0.3rem solid ${({ theme }) => theme.colors.buttonBlue};
  border-radius: 0.4rem;
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const PageNumber = styled(PageControlButton)<{ selected: boolean }>`
  ${({ theme, selected }) => `
      color: ${theme.colors.darkblue};
      ${selected && SelectedPageStyle}
    `}
`;
